import { Stack, Box, Typography } from '@mui/material'
import StoreFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'
import { observer } from 'mobx-react-lite'
import styled from '@emotion/styled'
import phoneIcon from './Assets/phone.svg'
import emailIcon from './Assets/email.svg'
import authenticationIcon from './Assets/authentication.svg'
import vatRegistrationIcon from './Assets/vat.svg'
import { toJS } from 'mobx'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

const ContactUsSaudiarabia = observer(() => {
    const contact = toJS(StoreFeelGreat.GetContent('contact'))
    const { width } = useSizeWindow() 
    
    return (
        <BoxStyled>
            <Stack sx={{ minWidth: 'fit-content' }}>
                <Typography variant="h2" sx={{ fontWeight: 600, color: '#153862', fontSize: '40px', textAlign: width <= 1100 && 'center' }}>
                    <T>contact_us</T>
                </Typography>
            </Stack>

            <ContainerStyled>
                <StackStyled>
                    <img src={phoneIcon} alt="phone" width={'34px'} height={'36px'} />
                    <TitleStyled variant="h4">
                        <T>phone</T>
                    </TitleStyled>
                    <DescriptionStyled>
                        {contact.phone}
                    </DescriptionStyled>
                </StackStyled>

                <StackStyled>
                    <img src={emailIcon} alt="email" width={'34px'} height={'36px'} />
                    <TitleStyled variant="h4">
                        <T>email</T>
                    </TitleStyled>
                    <DescriptionStyled>
                        {contact.email}
                    </DescriptionStyled>
                </StackStyled>

                <StackStyled>
                    <img src={vatRegistrationIcon} alt="email" width={'34px'} height={'36px'} />
                    <TitleStyled variant="h4">
                        <T>vat_registration</T>
                    </TitleStyled>
                    <DescriptionStyled>
                        <T>number</T> 312007181400003
                    </DescriptionStyled>
                </StackStyled>

                <StackStyled>
                    <img src={authenticationIcon} alt="email" width={'34px'} height={'36px'} />
                    <TitleStyled variant="h4">
                        <T>authentication_number</T>
                    </TitleStyled>
                    <DescriptionStyled>
                        0000173056
                    </DescriptionStyled>
                </StackStyled>
            </ContainerStyled>
        </BoxStyled>
    )
})

const BoxStyled = styled(Box)`
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 1400px) {
        flex-direction: row;
        gap: 120px;
    }

    @media screen and (min-width: 1730px) {
        gap: 220px;
    }
`

const ContainerStyled = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media screen and (min-width: 1100px) {
        width: 100%;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
    }

    @media screen and (min-width: 1700px) {
        width: 100%;
        gap: 0px;
        justify-content: space-between;
    }
`

const StackStyled = styled(Stack)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;

    @media screen and (min-width: 880px) {
        max-width: 300px;
        margin-top: 40px;
    }

    @media screen and (min-width: 1400px) {
        max-width: 350px;
        margin-top: 16px;
    }
`

const  TitleStyled = styled(Typography)`
    fontFamily: 'Poppins, NotoSansThai';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #153862;
    margin-top: 25px;
`

const DescriptionStyled = styled(Typography)`
    fontFamily: 'Poppins, NotoSansThai';
    font-style: normal;
    font-weight: 400;
    font-size: 16px !important;
    line-height: 24px;
    color: #153862;
    text-align: center;
`
export default ContactUsSaudiarabia